const appsRoutes = [
    {
        path: '/apps',
        name: 'apps',
        component: () => import('@/views/AppsView.vue'),
        meta: {
            title: 'Aplicativos',
            internalValidation: true
        }
    },
    {
        // Rota independente: /apps/:id nao e mais filha de AppsView para
        // evitar renderizar a lista de apps + detalhes ao mesmo tempo.
        // Reaproveitamos o name 'app' e o path /apps/:id para consistencia.
        path: '/apps/:id',
        name: 'app',
        component: () => import('@/views/AppDetailsView/AppDetailsView.vue'),
        meta: {
            title: 'Detalhes do aplicativo',
            internalValidation: true
        }
    },
    {
        // Formulario da homologacao self-service (JIMEA-1006).
        path: '/apps/:id/homologation',
        name: 'app-homologation',
        component: () => import('@/views/HomologationRequestView/HomologationRequestView.vue'),
        meta: {
            title: 'Homologação do aplicativo',
            internalValidation: true
        }
    },
    {
        path: '/app/:id/status',
        name: 'app-status',
        component: () => import('@organisms/AppSuccess/AppSuccess.vue'),
        meta: {
            internalValidation: true
        }
    }
]

export default appsRoutes
